<script setup>
import { useReadingPlanStore, } from '@/assets/js/src/modules/readingPlan/_pinia/readingPlan'
import { onBeforeUnmount, } from 'vue'
import { getActivePinia, } from 'pinia'

onBeforeUnmount(() => {
    useReadingPlanStore(getActivePinia()).$reset()
})
</script>

<template>
    <router-view v-slot="{ Component, }">
        <keep-alive
            include="ReadingPlanList"
            max="1"
        >
            <component :is="Component" />
        </keep-alive>
    </router-view>
</template>
